/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamRevisionReviewMutationRequest,
  PostApiV1ExamRevisionReviewMutationResponse,
  PostApiV1ExamRevisionReview400,
  PostApiV1ExamRevisionReview401,
  PostApiV1ExamRevisionReview500,
} from "../../types/examRevisionController/PostApiV1ExamRevisionReview.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamRevisionReview } from "../../clients/examRevisionController/postApiV1ExamRevisionReview.ts";

export const postApiV1ExamRevisionReviewMutationKey = () =>
  [{ url: "/api/v1/exam/revision/review" }] as const;

export type PostApiV1ExamRevisionReviewMutationKey = ReturnType<
  typeof postApiV1ExamRevisionReviewMutationKey
>;

export function postApiV1ExamRevisionReviewMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1ExamRevisionReviewMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1ExamRevisionReviewMutationKey();
  return mutationOptions<
    PostApiV1ExamRevisionReviewMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionReview400
      | PostApiV1ExamRevisionReview401
      | PostApiV1ExamRevisionReview500
    >,
    { data?: PostApiV1ExamRevisionReviewMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1ExamRevisionReview(data, config);
    },
  });
}

/**
 * @description Salva as alterações de revisão da prova gerada por IA (pt-BR): atualiza título, instrução, questões e opções. Propaga a correção das respostas para as questões traduzidas por índice e aciona a tradução automática para idiomas cujo conteúdo esteja vazio ou quando solicitado via 'shouldTranslate'. **(Requer Authorization para autenticação)**
 * @summary Salvar revisão da prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/review}
 */
export function usePostApiV1ExamRevisionReview<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamRevisionReviewMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamRevisionReview400
        | PostApiV1ExamRevisionReview401
        | PostApiV1ExamRevisionReview500
      >,
      { data?: PostApiV1ExamRevisionReviewMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1ExamRevisionReviewMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1ExamRevisionReviewMutationKey();

  const baseOptions = postApiV1ExamRevisionReviewMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ExamRevisionReviewMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionReview400
      | PostApiV1ExamRevisionReview401
      | PostApiV1ExamRevisionReview500
    >,
    { data?: PostApiV1ExamRevisionReviewMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1ExamRevisionReviewMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionReview400
      | PostApiV1ExamRevisionReview401
      | PostApiV1ExamRevisionReview500
    >,
    { data?: PostApiV1ExamRevisionReviewMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamRevisionReviewMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionReview400
      | PostApiV1ExamRevisionReview401
      | PostApiV1ExamRevisionReview500
    >,
    { data?: PostApiV1ExamRevisionReviewMutationRequest },
    TContext
  >;
}
